<template>
  <v-card class="land-card px-3 py-4 grey lighten-4" tile flat>
    <img
      @error="errorImage"
      class="d-block land-card_img"
      :src="img"
      width="100%"
    />

    <div>
      <div
        v-if="reference"
        class="
          primary--text
          text--lighten-1 text-body-2
          font-weight-regular
          mt-1
        "
      >
        Ref.: {{ reference }}
      </div>

      <div class="primary--text text--lighten-1 text-body-1 mt-1">
        <span v-if="district" class="font-weight-medium">
          {{ district }}
        </span>

        <span v-if="district && city" class="font-weight-regular"> | </span>

        <span v-if="city" class="font-weight-regular">
          {{ city + " " + state }}
        </span>
      </div>

      <div v-if="price" class="primary--text text-h6 font-weight-bold mt-1">
        {{ price }}
      </div>

      <v-divider class="mt-2 mb-2" />

      <div class="d-flex align-center">
        <v-icon size="14" left>fa-expand-arrows-alt</v-icon>{{ area }}
      </div>

      <v-divider class="mt-2 mb-2" />

      <v-btn
        v-if="informations.whatsapp"
        :href="whatsappLink"
        target="_blank"
        color="#66BB6A"
        width="max-content"
        depressed
        tile
      >
        <v-icon color="white" size="20" left> fab fa-whatsapp </v-icon>
        <div class="white--text text-body-1 text-none font-weight-medium">
          Fale com o Corretor
        </div>
      </v-btn>
    </div>

    <v-sheet
      class="d-flex flex-column align-start justify-center position-relative"
      color="transparent"
      height="100%"
    >
      <v-btn
        v-if="canShare"
        @click="share"
        class="text-none white--text share-btn"
        color="blue"
        depressed
        small
      >
        <v-icon size="16" left>fas fa-share-alt</v-icon>
        <span>Compartilhar</span>
      </v-btn>

      <div
        v-if="text"
        class="
          primary--text
          text-caption text-sm-body-2 text-justify
          font-weight-regular
          pt-8 pt-md-10
          land-card_text
          ck-content
        "
        v-html="text"
      ></div>
    </v-sheet>
  </v-card>
</template>

<script>
import { getWhatsappLinkFromPhone } from "../../utils/getWhatsappLinkFromPhone";
import DefaultImg from "../../assets/img/default-img.png";

export default {
  props: {
    reference: String,
    img: String,
    district: String,
    text: String,
    city: String,
    state: String,
    area: String,
    price: String,
    price_per_area: String,
    to: String,
  },
  data: () => ({
    dialog: false,
    index: null,
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    whatsappLink() {
      return (
        getWhatsappLinkFromPhone(this.informations.whatsapp) +
        "?text=Olá, me interessei neste imóvel e quero falar com um corretor!%0A" +
        location.href
      );
    },
    gallery() {
      if (!this.img || !this.img.list) return [];

      return this.img.list.map(
        ({ path }) =>
          this.files + path + "?resize=1&" + (this.xs ? "w=600" : "w=1920")
      );
    },
    canShare() {
      return !!navigator.share;
    },
  },
  methods: {
    errorImage(e) {
      e.target.src = DefaultImg;
    },
    share() {
      const shareData = {
        url: this.to,
      };

      if (navigator.share) {
        navigator.share(shareData);
        return;
      }
    },
  },
};
</script>

<style lang="scss">
.land-card {
  display: grid;
  grid-template-columns: 300px 280px auto;
  align-items: center;
  gap: 12px;

  @media screen and (max-width: 1279.9px) {
    & > :last-child {
      grid-column: 1 / -1;
    }
  }

  .share-btn {
    @media screen and (min-width: 1280px) {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  &_img {
    aspect-ratio: 880 / 570;
    object-fit: cover;
    width: 100%;
  }

  &_btns {
    display: grid;
    grid-auto-flow: column;
    gap: 8px;
  }

  &_price-to-settle {
    border: 1px solid #616161 !important;
    border-radius: 12px;
    padding: 4px 8px;
  }

  &_text {
    line-height: 1.6 !important;
  }

  &_text * {
    background-color: initial !important;
  }
}

@media screen and (max-width: 1264px) {
  .land-card {
    grid-template-columns: 240px 1fr 1fr;

    > :nth-child(2) {
      grid-column-end: span 2;
    }
  }
}

@media screen and (max-width: 600px) {
  .land-card {
    grid-template-columns: 1fr;

    > :nth-child(2) {
      grid-column-end: span 1 !important;
    }

    &_img {
      aspect-ratio: 1.618;
    }
  }
}
</style>
